module.exports = __webpack_public_path__ + "img/re.1ffe3e40.svg";